module.exports = __webpack_public_path__ + "2a43a4d61cd134d818ff1a65b22a37cd.jpg";